import ApiService from "../apiServiceMaster.js";
// import ApiServiceMasterCache from "../apiServiceMasterCache.js";

const querystring = require("querystring");
var ExceptionService = {
  findAll: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "exception";
      $options.method = "get";

      if ($data) {
        $options.url = "exception?" + querystring.stringify($data);
        console.log($options.url);
      }
      ApiService.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  
  checkDublicate: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "checkDublicate";
      $options.method = "get";

      if ($data) {
        $options.url = "checkDublicate?" + querystring.stringify($data);
        console.log($options.url);
      }
      ApiService.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


  getExceptionList: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getExceptionList";
      $options.method = "get";

      if ($data) {
        $options.url = "getExceptionList?" + querystring.stringify($data);
        console.log($options.url);
      }
      ApiService.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEmailException: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getEmailException";
      $options.method = "get";

      if ($data) {
        $options.url = "getEmailException?" + querystring.stringify($data);
        console.log($options.url);
      }
      ApiService.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


  findOne: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "exception/" + $data;
      console.log($options.url);
      $options.method = "get";
      if (!$data) {
        $options.data = $data;
      }
      ApiService.request($options)
        .then((response) => {
          // console.log('Gpt the data');
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.data = $data;
      $options.url = "exception/" + $data.id;
      $options.method = "post";
      console.log($options);
      ApiService.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  create: function($data) {
    return new Promise(function(resolve, reject) {
      var $options = {};
      $options.data = $data;
      $options.url = "exception";
      $options.method = "post";
      console.log($options);
      ApiService.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default ExceptionService;
